import type { ApiDecompositionNode, DecompositionNode } from 'api/data/projects/types';
import { getAutoIdAndPrimary } from 'api/project-nodes/types';

export function toDecompositionNode(apiNode: ApiDecompositionNode, parentId: string | null): DecompositionNode {
  const { autoId, primary } = getAutoIdAndPrimary(apiNode.properties);
  const autoIdProp = Object.values(apiNode.properties).find((property) => property.isAutoId);

  const isAutoIdPrimary = autoIdProp?.isPrimary;
  const titleValue = isAutoIdPrimary ? '' : String(primary ?? '');

  return {
    id: apiNode.id,
    parentId,
    title: titleValue,
    subtitle: String(autoId ?? ''),
    hasChildren: apiNode.hasChildren
  };
}
